import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useNavigate } from 'react-router-dom';

const GeneralError: React.FC = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    // Clear any stored data and go to a safe state
    localStorage.removeItem('tableId');
    navigate('/');
  };

  return (
    <Box sx={{
      minHeight: '100vh',
      width: '100vw',      
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 2,
      paddingTop: 'calc(env(safe-area-inset-top, 0px) + 16px)',
      paddingBottom: 'env(safe-area-inset-bottom, 0px)',
      paddingLeft: 'env(safe-area-inset-left, 0px)',
      paddingRight: 'env(safe-area-inset-right, 0px)',
    }}>
      <Paper sx={{
        maxWidth: 400,
        width: '100%',
        padding: 4,
        borderRadius: 3,
        textAlign: 'center',
        boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(10px)',
      }}>
        <Box sx={{ mb: 3 }}>
          <ErrorOutlineIcon sx={{ 
            fontSize: 64, 
            color: '#f44336',
            mb: 2,
            filter: 'drop-shadow(0 2px 4px rgba(244,67,54,0.3))'
          }} />
        </Box>

        <Typography variant="h4" sx={{
          fontWeight: 700,
          color: '#1a1a1a',
          mb: 2,
          fontSize: { xs: '1.5rem', sm: '2rem' }
        }}>
          Ha ocurrido un error
        </Typography>

        <Typography variant="body1" sx={{
          color: '#666',
          mb: 3,
          lineHeight: 1.6,
          fontSize: '1rem'
        }}>
          Lo sentimos, no pudimos completar tu solicitud en este momento. 
          Por favor, intenta nuevamente más tarde.
        </Typography>

        <Typography variant="body2" sx={{
          color: '#999',
          mb: 4,
          fontSize: '0.9rem',
          fontStyle: 'italic'
        }}>
          Si el problema persiste, contacta al personal del restaurante para obtener ayuda.
        </Typography>

        <Box sx={{
          padding: 2,
          backgroundColor: '#f8f9fa',
          borderRadius: 2,
          border: '1px solid #e9ecef',
          mb: 3
        }}>
          <Typography variant="body2" sx={{
            color: '#6c757d',
            fontSize: '0.85rem',
            lineHeight: 1.4
          }}>
            <strong>💡 Sugerencia:</strong> Puedes intentar escanear nuevamente el código QR de tu mesa para continuar con tu pedido.
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
};

export default GeneralError; 